module.exports = __webpack_public_path__ + "static/media/01_Maf_NuestroEquipo_DraFromow.c-01.d70e9798.png";